import { render, staticRenderFns } from "./FormularioPregunta.vue?vue&type=template&id=0da8a2fc&scoped=true"
import script from "./FormularioPregunta.vue?vue&type=script&lang=js"
export * from "./FormularioPregunta.vue?vue&type=script&lang=js"
import style0 from "./FormularioPregunta.vue?vue&type=style&index=0&id=0da8a2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8a2fc",
  null
  
)

export default component.exports